import { render, staticRenderFns } from "./AboutPreAuth.vue?vue&type=template&id=2468e829"
import script from "./AboutPreAuth.vue?vue&type=script&lang=js"
export * from "./AboutPreAuth.vue?vue&type=script&lang=js"
import style0 from "./AboutPreAuth.vue?vue&type=style&index=0&id=2468e829&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports